module.exports = __webpack_public_path__ + "img/clays-ark.0df393fc.png";